import '../../resources/css/login/ResetPasswordPage.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { forwardLogin } from '../../actions/login/index';
import ForgotPwdForm from './ForgotPwdForm';

class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);

    // this.updateShow = this.updateShow.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    const { forwardLogin } = this.props;
    forwardLogin(null);
  }

  render() {    
    return (
      <div className="reset-password-page form-custom">
          <div className='form-title'>Reset Password</div>
          <ForgotPwdForm></ForgotPwdForm>
      </div>
    )
  }
}

export default connect(
  null,
  { forwardLogin }
)(ResetPasswordPage)